// ─── Workflow Groupings ───
// The 10 audit modules organized by accounting workflow

export const WORKFLOWS = {
  recovery: {
    key: 'recovery',
    label: 'Money Recovery',
    tagline: 'What are we owed?',
    accent: '#B45309',
    accentBg: '#FEF3C7',
    icon: '$',
    modules: ['credits', 'unreturned-cores', 'never-received'],
  },
  accuracy: {
    key: 'accuracy',
    label: 'Purchase Accuracy',
    tagline: 'Are our books right?',
    accent: '#1D4ED8',
    accentBg: '#DBEAFE',
    icon: '\u2713',
    modules: ['missing-invoices', 'cost-discrepancies', 'invalid-ro', 'duplicate-orders', 'received-not-on-ticket'],
  },
  intelligence: {
    key: 'intelligence',
    label: 'Vendor Intelligence',
    tagline: 'How are vendors behaving?',
    accent: '#6D28D9',
    accentBg: '#EDE9FE',
    icon: '\u2197',
    modules: ['vendor-price-trends', 'cod-reconciliation'],
  },
};

export const MODULES = {
  'credits': {
    key: 'credits',
    label: 'Outstanding Credits',
    workflow: 'recovery',
    endpoint: '/api/modules/credits',
    description: 'Returns awaiting vendor credit',
    priority: 1,
  },
  'unreturned-cores': {
    key: 'unreturned-cores',
    label: 'Unreturned Cores',
    workflow: 'recovery',
    endpoint: '/api/modules/unreturned-cores',
    description: 'Core deposits at risk of forfeiture',
    priority: 2,
  },
  'never-received': {
    key: 'never-received',
    label: 'Never Received',
    workflow: 'recovery',
    endpoint: '/api/modules/ordered-never-received',
    description: 'Ordered but never delivered',
    priority: 3,
  },
  'missing-invoices': {
    key: 'missing-invoices',
    label: 'Missing Invoices',
    workflow: 'accuracy',
    endpoint: '/api/modules/missing-invoices',
    description: 'Parts without purchase orders',
    priority: 4,
  },
  'cost-discrepancies': {
    key: 'cost-discrepancies',
    label: 'Cost Mismatches',
    workflow: 'accuracy',
    endpoint: '/api/modules/cost-discrepancies',
    description: 'PO cost vs RO cost differences',
    priority: 5,
  },
  'invalid-ro': {
    key: 'invalid-ro',
    label: 'Invalid RO Refs',
    workflow: 'accuracy',
    endpoint: '/api/modules/invalid-ro-refs',
    description: 'POs linked to bad repair orders',
    priority: 6,
  },
  'duplicate-orders': {
    key: 'duplicate-orders',
    label: 'Duplicate Orders',
    workflow: 'accuracy',
    endpoint: '/api/modules/duplicate-orders',
    description: 'Same part ordered multiple times',
    priority: 7,
  },
  'received-not-on-ticket': {
    key: 'received-not-on-ticket',
    label: 'Received, Not Billed',
    workflow: 'accuracy',
    endpoint: '/api/modules/received-not-on-ticket',
    description: 'Parts received but not on any RO',
    priority: 8,
  },
  'vendor-price-trends': {
    key: 'vendor-price-trends',
    label: 'Price Changes',
    workflow: 'intelligence',
    endpoint: '/api/modules/vendor-price-changes',
    description: 'Vendor price movement over time',
    priority: 9,
  },
  'cod-reconciliation': {
    key: 'cod-reconciliation',
    label: 'COD Payments',
    workflow: 'intelligence',
    endpoint: '/api/modules/cod-orders',
    description: 'Cash-on-delivery payment tracking',
    priority: 10,
  },
};

export const ALERT_THRESHOLD_DAYS = 30;

export function getSeverity(days) {
  if (days >= 45) return 'critical';
  if (days >= ALERT_THRESHOLD_DAYS) return 'warning';
  return 'info';
}
